import React from "react";

export default function playicon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none">
            <path d="M1 1L11 7.5L1 14V1Z" stroke="#4C5BE0" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}
